import { render, staticRenderFns } from "./MsTagNew.vue?vue&type=template&id=7ffcc538"
import script from "./MsTagNew.vue?vue&type=script&lang=js"
export * from "./MsTagNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports